/* eslint-disable complexity */
/* eslint-disable react/prop-types */
/* eslint-disable max-statements */
/* eslint-disable max-lines, import/no-named-as-default-member */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import logger from '@tcp/core/src/utils/loggerInstance';
import isEqual from 'lodash/isEqual';
import PropTypes, { func, bool } from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import {
  getAddressList,
  getAddressListPlcc,
} from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.actions';
import {
  getBossStatus,
  getDefaultAddress,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { fetchPageLayout, setCartsSessionStatus } from '@tcp/core/src/reduxStore/actions';
import { isGuest as isGuestUser } from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import names from '@tcp/core/src/constants/eventsName.constants';
import {
  getLogoutInProgress,
  getQuickViewLoader,
} from '@tcp/core/src/components/common/molecules/Loader/container/Loader.selector';
import {
  getUniqueId,
  getModalState,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import ApplyNowModalPLCCReducer from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.reducer';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import PaymentReducer from '@tcp/core/src/components/features/account/Payment/container/Payment.reducer';
import PaymentSaga from '@tcp/core/src/components/features/account/Payment/container/Payment.saga';
import DeleteCardSaga from '@tcp/core/src/components/features/account/Payment/container/DeleteCard.saga';
import DefaultPaymentSaga from '@tcp/core/src/components/features/account/Payment/container/DefaultPayment.saga';
import BillingPaymentSaga from '@tcp/core/src/components/features/CnC/Checkout/organisms/BillingPaymentForm/container/CreditCard.saga';
import CartTileReducer from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.reducer';
import CartPageSaga from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.saga';
import { fetchBagOutfitProducts } from '@tcp/core/src/components/common/organisms/StyliticsProductTabList/container/StyliticsProductTabList.actions';
import {
  applyCoupon,
  setLastAppliedCoupon,
  setOpenCouponDetailModalActn,
} from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.actions';
import {
  getIsChangeRecalForEcom,
  getCartsSessionStatus,
  getIsDisableBagAnchoring,
  getIsSyteEnabled,
  getIsExpressAfterpayEnabled,
  getAfterPayMinOrderAmount,
  getAfterPayMaxOrderAmount,
  getIsEstimatedTotalOnBag,
  getIsNewCouponPlacementEnable,
  estimatedTaxBagPageEnabled,
  getIsInternationalShipping,
  getRecommendationsPlacementAbTest,
  getcouponSectionNewDesign,
  getIsNewPlccEnabledAbtest,
  getIsCouponSmoothScrollEnabled,
  getIsRecommendationCarouselRedesignEnabled,
  getCouponCodePlacementAbtest,
  getIsBossEnabled,
  getBossUnavailableSwitch,
  getIsShareCartEnabled,
  getIsBIACombinedCarouselKillSwitch,
  getIsOutfitsOnBagEnabled,
  getOutfitCountOnBag,
  getIsFreeShippingMessagingEnabled,
  getDynamicShippingCharge,
  getIsFreeShippingProgressBarDisabled,
  getIsSiteWidePromoBannerAbTestEnabled,
  getIsExtendedHolidayReturnsBannerAbTestEnabled,
  getIsHolidayGetItByMessageBannerAbTestEnabled,
  getDeadlineDateAndTime,
  getDesktopProductTileCleanUpDisabled,
  getIsShowBagSimplifiedHeader,
  getInitialSFLItemsQty,
  getPlccOfferPercentage,
  freeShippingMessageForPromos,
  getIsEnableShipmentTilesForInternationalSite,
  getIsHeaderScrollViewDisabled,
  getMobileWebProductTileEnhancement,
  getIsRedesignGlobalHeaderEnabled,
  getNewGlobalErrorMessage,
  getIsPriceDropNotificationEnabled,
  priceDropPercentage,
  priceDropHolidayList,
  getIsPriceDropNotificationApiEnabled,
  getIsPayPalDisabled,
  getIsPayPalEnabled,
  getIsShowLowInventoryBanner,
  getIsShowLowInventoryBannerForOldDesign,
  getIsHideStickyCheckoutButton,
  getIsStickyCheckoutAbTestEnabled,
  getIsAdyenPaymentEnabled,
  getIsPayPalDisabledForPickupOrders,
  getIsGlobalDefaultHeaderRedesignEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  setClickAnalyticsData,
  trackClick,
  trackPageView,
  resetClickAnalyticsData,
  updatePageData,
} from '@tcp/core/src/analytics/actions';
import {
  isRememberedUser,
  getUserId,
  getIsGuest,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { isApplePayEligible, parseBoolean } from '@tcp/core/src/utils/utils';
import { readCookie, removeCookie, removeAbsoluteCookie } from '@tcp/core/src/utils/cookie.util';
import {
  resetEddData,
  clearEddTTL,
  updateShippingCode,
} from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.actions';
import EddReducer from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.reducer';
import EddSaga from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.saga';
import {
  couponCalculatetax,
  resetTaxEstimationValue,
  saveShareCartActn,
  saveShareCartErr,
  setDefaultBanner,
  togglePlccLoginModal,
  updatePriceDropItemValues,
  updatePriceDropItemValuesInSfl,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import {
  updateRecommendationsLoading,
  clearRecommendationData,
} from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.actions';
import {
  getIsMiniBagOpen,
  getOrderShipments,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import {
  triggerPriceDropNotification,
  updateStoreItem as updateItem,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.actions';
import {
  getFirstTimeCaptureBanner,
  getFirstTimeCaptureShopMenu,
} from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import { getCardsList } from '@tcp/core/src/components/features/account/Payment/container/Payment.selectors';
import { getCD66Data } from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.selectors';
import { getCD81Data } from '@tcp/core/src/components/features/account/BirthdayModule/container/BirthdayModule.selectors';
import { getBagOutfitProducts } from '@tcp/core/src/components/common/organisms/StyliticsProductTabList/container/StyliticsProductTabList.selector';
import AddressBookReducer from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.reducer';
import AddressBookSaga from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.saga';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';
import BagPageSelector, {
  getECOMStatus,
  getFreeShippingThresholdValue,
  getFreeShippingType,
  getHasSflCallCompleted,
  getIsFreeShippingCouponApplied,
  getIsPlccCheckoutEnabled,
  getIsPlccShippingAddressUpdate,
  getShareCartError,
  isECOMStatus,
  isMixedOrderStatus,
  isPickuOrderStatus,
} from './BagPage.selectors';
import BagPage from '../views/BagPage.view';
import BAG_PAGE_ACTIONS from './BagPage.actions';
import {
  getCartOrderList,
  getIsCartItemsUpdating,
  getIsCartItemsSFL,
  getIsSflItemRemoved,
  getCartItemsSflError,
  getPageName,
  getIsSflItemMovedToBag,
  getIsBagItemRemoved,
} from '../../CartItemTile/container/CartItemTile.selectors';
import {
  getUserLoggedInState,
  getIsRegisteredUserCallDone,
  isPlccUser,
} from '../../../account/User/container/User.selectors';
import { getBonusPointsSwitch } from '../../../../common/organisms/BonusPointsDays/container/BonusPointsDays.selectors';
import CHECKOUT_ACTIONS, {
  setVenmoPaymentInProgress,
  setVenmoPickupMessageState,
  setApplePaymentInProgress,
  setVenmoShippingMessageState,
  isExpressCallThroughPlccICFailure,
  setExpressAfterpayFlow,
} from '../../Checkout/container/Checkout.action';
import checkoutSelectors, { getShippingValues } from '../../Checkout/container/Checkout.selector';
import {
  toastMessageInfo,
  toastMessagePosition,
} from '../../../../common/atoms/Toast/container/Toast.actions';
import utils, {
  isClient,
  scrollToElement,
  isCanada,
  fireEnhancedEcomm,
  setSessionStorage,
  getSessionStorage,
  getAPIConfig,
} from '../../../../../utils';
import { getSaveForLaterSwitch } from '../../SaveForLater/container/SaveForLater.selectors';
import {
  getGrandTotal,
  getGiftCardsTotal,
  getLedgerSummaryData,
  getProductTotal,
} from '../../common/organism/OrderLedger/container/orderLedger.selector';
import { getIsPickupModalOpen } from '../../../../common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import {
  getAppliedExpiredCouponListState,
  getLastAppliedCouponData,
  getOpenCouponDetailModal,
} from '../../common/organism/CouponAndPromos/container/Coupon.selectors';
import PlaceCashSelector from '../../PlaceCashBanner/container/PlaceCashBanner.selectors';
import BAGPAGE_CONSTANTS from '../BagPage.constants';
import BagPageUtils from '../views/Bagpage.utils';
import ConfirmationSelector from '../../Confirmation/container/Confirmation.selectors';
import { getOrderTotalAmount } from '../../SinglePageCheckout/container/SinglePageCheckout.selector';
import GiftCardsSelectors from '../../Checkout/organisms/GiftCardsSection/container/GiftCards.selectors';
import { getCardList } from '../../../account/Payment/container/Payment.actions';
import SinglePageCheckoutSaga from '../../SinglePageCheckout/container/SinglePageCheckout.saga';
import CheckoutDynamicSaga from '../../Checkout/container/Checkout.saga';
import { toggleSPC } from '../../SinglePageCheckout/container/SinglePageCheckout.actions';
import { toggleApplyNowModal } from '../../../../common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.actions';
import {
  getBossUnavailableList,
  moveItemsToBossUnavailableList,
} from '../../CartItemTile/molecules/BossUnavailableTile/container/BossUnavailable.actions';
import {
  getBossUnavailableProduct,
  getBossUnavailableProductInList,
} from '../../CartItemTile/molecules/BossUnavailableTile/container/BossUnavailable.selector';
import { getPLCCDiscountValue } from '../../../../common/organisms/Promotions/container/Promotions.selectors';

let executed = false;
let cardCallExecuted = false;
let triggeredEmptyBagTracking = false;

const shouldTaxCall = (cartOrderItems, prevCartOrderItems) =>
  cartOrderItems && cartOrderItems !== 0 && cartOrderItems !== prevCartOrderItems;

const getItemPartNumber = (orderItems) => {
  if (orderItems && orderItems.size) {
    return orderItems?.map((item) => item?.getIn(['productInfo', 'itemPartNumber']));
  }
  return '';
};

const shouldEDDCall = (
  totalCount,
  prevTotalItems,
  prevCartOrderItems,
  cartOrderItems,
  clearEddCache
) => {
  if (
    (totalCount && totalCount !== prevTotalItems) ||
    !isEqual(getItemPartNumber(prevCartOrderItems), getItemPartNumber(cartOrderItems))
  ) {
    clearEddCache();
    return true;
  }
  return null;
};
const resetEstimatedTax = (
  checkoutAddress,
  resetTaxEstimationValueActn,
  isCouponCalculateTax,
  resetCoupontaxFlag
) => {
  const { address } = checkoutAddress || {};
  if (!address?.addressLine1) {
    resetTaxEstimationValueActn();
  }
  if (isCouponCalculateTax) {
    resetTaxEstimationValueActn();
    resetCoupontaxFlag(false);
  }
};

const getOrderTotal = (calculatedEstimatedTax, orderBalanceTotal) => {
  return calculatedEstimatedTax
    ? orderBalanceTotal + parseFloat(calculatedEstimatedTax || 0)
    : orderBalanceTotal;
};

export class BagPageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      triggerTracking: true,
    };

    this.fromMiniBag = false;
    this.isApplePayVisible = this.getApplePayVisible();
  }

  static contextType = LabelsContext;

  // eslint-disable-next-line sonarjs/cognitive-complexity
  componentDidMount() {
    const {
      fetchNeedHelpContent,
      resetAnalyticsData,
      bagPageServerError,
      clearCheckoutServerError,
      venmoOrderConfirmationId,
      airmilesBannerContentId,
      setMaxItemErrorAction,
      setVMPItemErrorAction,
      setOOSErrorAction,
      setCouponMergeErrorAction,
      navigation,
      trackClickAction,
      setClickAnalyticsDataBag,
      router,
      resetEDDCall,
      setCartItemsSflError,
      resetTaxEstimationValueActn,
      cartItemSflError,
      setExpressCallThroughPlccICFailure,
      getDefaultAddressValue,
      isGuest,
      checkoutAddress,
      isCouponCalculateTax,
      resetCoupontaxFlag,
      isCardsList,
      getFullCardsList,
      getAddressPlccActn,
    } = this.props;

    setExpressCallThroughPlccICFailure(false);
    resetEDDCall(true);
    setExpressAfterpayFlow(false);
    if (isEmpty(getDefaultAddressValue) && !isGuest) {
      getAddressPlccActn();
    }
    if (isEmpty(isCardsList) && !isGuest) {
      getFullCardsList();
    }
    resetEstimatedTax(
      checkoutAddress,
      resetTaxEstimationValueActn,
      isCouponCalculateTax,
      resetCoupontaxFlag
    );
    resetAnalyticsData();
    this.fetchSFLItems();
    this.fetchInitialActions();

    const fromNewATBModal = (navigation && navigation.getParam('comingFromNewATBModal')) || false;
    if (fromNewATBModal) {
      const name = names.screenNames.atb_drawer_view_bag;
      const module = 'browse';
      const clickData = { customEvents: ['event143'] };
      setClickAnalyticsDataBag(clickData);
      trackClickAction({ name, module });
    }
    const needHelpContents = [venmoOrderConfirmationId];

    if (isCanada()) {
      needHelpContents.push(airmilesBannerContentId);
    }

    fetchNeedHelpContent(needHelpContents);
    const {
      setVenmoPickupState,
      setVenmoShippingState,
      setVenmoInProgress,
      setAppleInProgress,
      getHomePageLayout,
      layouts,
      isCartLoaded,
      cartOrderItems,
      User,
      APIConfig,
      session,
    } = this.props;
    const pageDataAdobe = {
      pageName: 'bag page',
      pageSection: 'shopping bag',
      pageSubSection: '',
      pageSubSection2: '',
      pageType: 'bag page',
    };
    setVenmoPickupState(false);
    setVenmoShippingState(false);
    setVenmoInProgress(false);
    setAppleInProgress(false);

    if (bagPageServerError) {
      clearCheckoutServerError({});
    }
    if (cartItemSflError) {
      setCartItemsSflError(null);
    }
    setMaxItemErrorAction(false);
    setOOSErrorAction(false);
    setVMPItemErrorAction(false);
    setCouponMergeErrorAction(false);
    const apiConfigObj = getAPIConfig();
    const { loadHomePageDataEnabled, timeOutGap } = apiConfigObj;
    // eslint-disable-next-line react/prop-types
    if (isCartLoaded && loadHomePageDataEnabled && !layouts.home) {
      const apiConfig = getAPIConfig();
      setTimeout(() => {
        getHomePageLayout(apiConfig);
      }, timeOutGap);
    }
    this.fromMiniBag = utils.getObjectValue(router, false, 'query', 'fromMiniBag');
    const { triggerTracking } = this.state;

    if (triggerTracking) {
      this.startBagAnalytics(cartOrderItems, []);
    }
    pushEventToAdobeAnalytics('page_view', { pageData: pageDataAdobe, User, APIConfig, session });
    this.checkForVMPErrors();
    triggeredEmptyBagTracking = false;
  }

  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps, this.props);
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  componentDidUpdate(prevProps) {
    const { isRegisteredUserCallDone: prevIsRegisteredUserCallDone } = prevProps;
    const {
      router,
      isRegisteredUserCallDone,
      bagPageIsRouting,
      isCartLoaded,
      pageName,
      resetEDDCall,
      isCartSupressOnBagUpdate,
      resetTaxEstimationValueActn,
      getDefaultAddressValue,
      isGuest,
      getAddressListActn,
      clearEddCache,
      isCardsList,
      getFullCardsList,
      rememberedUser,
      logoutInProgress,
    } = this.props;
    if (
      prevIsRegisteredUserCallDone !== isRegisteredUserCallDone &&
      !bagPageIsRouting &&
      !isCartSupressOnBagUpdate
    ) {
      this.fetchSFLItems();
      this.fetchInitialActions();
    }

    // Adding to avoid payment and address call on component update
    if (rememberedUser) {
      executed = true;
      cardCallExecuted = true;
    }

    if (isClient()) {
      const isSfl = utils.getObjectValue(router, undefined, 'query', 'isSfl');
      if (isSfl && isCartLoaded && pageName !== BAGPAGE_CONSTANTS.SHOPPING_BAG) {
        const headingElem = document.querySelector('.save-for-later-section-heading');
        const timer = setTimeout(() => {
          scrollToElement(headingElem);
          clearTimeout(timer);
        }, 700);
      }
    }
    const { cartOrderItems: prevCartOrderItems, totalCount: prevTotalItems } = prevProps;
    const { cartOrderItems, totalCount, setExpressCallThroughPlccICFailure } = this.props;
    const { triggerTracking } = this.state;
    if (!logoutInProgress && isEmpty(getDefaultAddressValue) && !isGuest && !executed) {
      executed = true;
      getAddressListActn();
    }
    if (!logoutInProgress && isEmpty(isCardsList) && !isGuest && !cardCallExecuted) {
      cardCallExecuted = true;
      getFullCardsList();
    }

    // Prevent pageload tracking after first pageload tracking
    if (triggerTracking) {
      this.startBagAnalytics(cartOrderItems, prevCartOrderItems);
    }
    if (
      shouldEDDCall(totalCount, prevTotalItems, prevCartOrderItems, cartOrderItems, clearEddCache)
    ) {
      setTimeout(() => {
        resetEDDCall();
      }, 100);
      setExpressCallThroughPlccICFailure(false);
    }
    if (shouldTaxCall(totalCount, prevTotalItems)) {
      resetTaxEstimationValueActn();
    }
    this.checkForMergeCartErrors();
    this.checkForVMPErrors();
  }

  componentWillUnmount() {
    const {
      resetBagLoadedState,
      resetAnalyticsData,
      setCouponMergeErrorAction,
      togglePlccModalStateAction,
      setLastAppliedCouponActn,
    } = this.props;
    resetBagLoadedState();
    resetAnalyticsData();
    this.setState({ triggerTracking: true });
    setCouponMergeErrorAction(false);
    togglePlccModalStateAction(false);
    setLastAppliedCouponActn(null);
  }

  validateCartMergeMessaging = (isGuest, showMaxItemError, showOOSError) =>
    !isGuest && !showMaxItemError && !showOOSError;

  checkForMergeCartErrors = async () => {
    const {
      setCouponMergeErrorAction,
      setMaxItemErrorAction,
      currentUserId,
      isGuest,
      showMaxItemError,
      showOOSError,
    } = this.props;
    if (this.validateCartMergeMessaging(isGuest, showMaxItemError, showOOSError)) {
      const notificationFlag = readCookie(`MC_${currentUserId}`);
      if (notificationFlag) {
        if (notificationFlag.indexOf('ex_quantity') !== -1) {
          setMaxItemErrorAction(true);
        }
        if (notificationFlag.indexOf('ex_coupon') !== -1) {
          setCouponMergeErrorAction(true);
        }
        removeCookie(`MC_${currentUserId}`);
      }
      this.setMergeCartErr();
    }
  };

  checkForVMPErrors = async () => {
    const { showVMPError, setVMPItemErrorAction } = this.props;
    if (!showVMPError) {
      const vMultiplePackError = readCookie('VMP_ERROR_KEY');

      if (vMultiplePackError) {
        setVMPItemErrorAction(true);
      }
      removeAbsoluteCookie('VMP_ERROR_KEY');
    }
  };

  setMergeCartErr = async () => {
    const { setMaxItemErrorAction, setOOSErrorAction } = this.props;

    const mergeCartErr = readCookie('MC_ERROR_KEY');
    if (mergeCartErr) {
      if (mergeCartErr.indexOf('ex_quantity') !== -1) {
        setMaxItemErrorAction(true);
      }
      if (mergeCartErr.indexOf('_ERR_MC_ITEM_OOS') !== -1) {
        setOOSErrorAction(true);
      }
      removeAbsoluteCookie('MC_ERROR_KEY');
    }
  };

  getCustomEventsForAnalytics = () => {
    try {
      let analyticSV = getSessionStorage('AnalyticsObj');
      analyticSV = typeof analyticSV === 'object' ? JSON.stringify(analyticSV) : analyticSV;
      const analyticsObj = (analyticSV && analyticSV.length && JSON.parse(analyticSV)) || {};
      const { metric2 } = analyticsObj;
      if (!metric2) {
        setSessionStorage({
          key: 'AnalyticsObj',
          value: JSON.stringify({ ...analyticsObj, metric2: false }),
        });
        const obj = {
          event: 'BagPage_CM2',
          CM2: '1',
        };
        fireEnhancedEcomm({
          isCustomEvent: true,
          event: obj,
        });
      }
    } catch (e) {
      const analyticsObj = getSessionStorage('AnalyticsObj');
      logger.error('Error Occured in getCustomEventsForAnalytics', {
        error: e,
        extraData: {
          component: 'BagPageCommonContainer',
          parsedObj: analyticsObj,
        },
      });
    }
  };

  getApplePayVisible = () => {
    const { isApplePayEnabled, rememberedUser, isApplePayRememberedUser } = this.props;
    return (
      isApplePayEnabled && isApplePayEligible() && !(!isApplePayRememberedUser && rememberedUser)
    );
  };

  getCustomData = (events, productsData, fromMiniBag, HEADER_CART) => {
    return {
      customEvents: events,
      products: productsData,
      pageNavigationText: fromMiniBag ? HEADER_CART : '',
    };
  };

  // eslint-disable-next-line complexity,sonarjs/cognitive-complexity
  startBagAnalytics = async (cartOrderItems, prevCartOrderItems) => {
    const {
      setClickAnalyticsDataBag,
      trackPageViewBag,
      router,
      updateBagPageData,
      cd66Data,
      cd81Data,
      totalCount,
      isCartLoaded,
    } = this.props;
    const events = ['scView', 'event80'];
    let fromMiniBag = false;
    events.push('scOpen');
    fromMiniBag = utils.getObjectValue(router, false, 'query', 'fromMiniBag');
    this.getCustomEventsForAnalytics();

    if (!isEqual(cartOrderItems, prevCartOrderItems) && events.length > 0) {
      const productsData =
        BagPageUtils.formatBagProductsData(cartOrderItems, { cd66Data }, { cd81Data }) || {};
      const olderProductsData =
        BagPageUtils.formatBagProductsData(prevCartOrderItems, { cd66Data }, { cd81Data }) || {};
      if (!isEqual(productsData, olderProductsData)) {
        const { SHOPPING_BAG, HEADER_CART } = BAGPAGE_CONSTANTS;
        updateBagPageData({
          pageName: SHOPPING_BAG,
          pageSection: SHOPPING_BAG,
          pageSubSection: SHOPPING_BAG,
          pageType: SHOPPING_BAG,
          pageShortName: SHOPPING_BAG,
        });
        const newProductData = productsData;
        const customData = this.getCustomData(events, newProductData, fromMiniBag, HEADER_CART);
        setClickAnalyticsDataBag(customData);
        pushEventToAdobeAnalytics('product_cart_view', productsData); // same call for both web and app
        trackPageViewBag({
          currentScreen: 'bagPage',
          pageData: {
            pageName: BAGPAGE_CONSTANTS.SHOPPING_BAG,
            pageSection: BAGPAGE_CONSTANTS.SHOPPING_BAG,
            pageSubSection: BAGPAGE_CONSTANTS.SHOPPING_BAG,
            pageType: BAGPAGE_CONSTANTS.SHOPPING_BAG,
            pageShortName: BAGPAGE_CONSTANTS.SHOPPING_BAG,
          },
        });
        this.setState({ triggerTracking: false });
      }
    }
    if (!triggeredEmptyBagTracking && isCartLoaded && totalCount === 0) {
      this.startEmptyBagAnalytics();
      triggeredEmptyBagTracking = true;
    }
  };

  startEmptyBagAnalytics = async () => {
    const { trackPageViewBag } = this.props;
    trackPageViewBag({
      currentScreen: 'emptyBagPage',
      pageData: {
        pageName: BAGPAGE_CONSTANTS.SHOPPING_BAG,
        pageSection: BAGPAGE_CONSTANTS.SHOPPING_BAG,
        pageSubSection: BAGPAGE_CONSTANTS.SHOPPING_BAG,
        pageType: BAGPAGE_CONSTANTS.SHOPPING_BAG,
        pageShortName: BAGPAGE_CONSTANTS.SHOPPING_BAG,
      },
    });
  };

  fetchInitialActions() {
    const { isRegisteredUserCallDone, initialActions, isRecalculateTaxes, isECOM, isGuest } =
      this.props;
    const isRecalc = isECOM && isRecalculateTaxes;
    if (isRegisteredUserCallDone) {
      initialActions(isRecalc, isGuest);
    }
  }

  async fetchSFLItems() {
    const { isRegisteredUserCallDone, fetchSflData } = this.props;
    if (isRegisteredUserCallDone) {
      fetchSflData();
    }
  }

  getTotalTaxAmount = () => {
    const {
      isEstimatedTaxBagPageEnabled,
      orderPriceBreakup,
      calculatedTax,
      isPlccShippingAddressUpdated,
    } = this.props;
    const { taxesTotal } = orderPriceBreakup;
    let tax;
    if (!isEstimatedTaxBagPageEnabled && (taxesTotal || taxesTotal === 0)) {
      tax = taxesTotal;
    } else if (isPlccShippingAddressUpdated) {
      tax = taxesTotal;
    } else {
      tax = parseFloat(calculatedTax || 0);
    }
    return tax;
  };

  getTotalAmount = () => {
    const {
      orderPriceBreakup,
      isSpcBag,
      isPlccShippingAddressUpdated,
      calculatedTax,
      isEstimatedTaxBagPageEnabled,
      isInternationalShipping,
    } = this.props;
    const {
      subTotal,
      shippingTotal,
      giftServiceTotal,
      giftCardsTotal,
      couponsTotal,
      savingsTotal,
      orderBalanceTotal: orderBalTotal,
      grandTotal,
    } = orderPriceBreakup;

    const giftCardTotal = isSpcBag ? 0 : giftCardsTotal;
    const totalTax = this.getTotalTaxAmount();
    const orderBalanceTotal =
      isEstimatedTaxBagPageEnabled && calculatedTax
        ? orderBalTotal + parseFloat(calculatedTax || 0)
        : orderBalTotal;
    const orderBalance = isSpcBag || isInternationalShipping ? orderBalanceTotal : grandTotal;
    const tax =
      ((totalTax || totalTax === 0) && isSpcBag) || isPlccShippingAddressUpdated
        ? totalTax
        : Number(calculatedTax);
    const orderTotalValue =
      subTotal +
      Number(tax) +
      shippingTotal +
      giftServiceTotal -
      giftCardTotal -
      couponsTotal -
      savingsTotal;
    return orderTotalValue || orderBalance;
  };

  getItemInfoDetails = (tile) => {
    const { productInfo, itemInfo, miscInfo } = tile || {};
    return {
      c_prodPartNo: productInfo?.productPartNumber,
      c_brand: productInfo?.itemBrand,
      c_TCPColor: productInfo?.color?.name,
      c_TCPStyleType: productInfo?.tcpStyleType,
      c_TCPProductIndStore: miscInfo?.TCPProductIndStore,
      c_TCPimages: productInfo?.imagePath,
      c_fit: productInfo?.fit || null,
      c_size: productInfo?.size,
      c_variant: productInfo?.variant,
      productId: productInfo?.generalProductId,
      itemId: itemInfo?.itemId,
      quantity: itemInfo?.quantity?.toString(),
      c_TCPStyleQTY: productInfo?.tcpStyleQty,
      c_TCPWebOnlyFlagStore: miscInfo?.isOnlineOnly,
      shipment_id: productInfo?.shipmentId,
      c_list_price: itemInfo?.wasPrice,
      c_multiPack: productInfo?.multiPack || false,
    };
  };

  render() {
    const {
      totalCount,
      orderItemsCount,
      orderItemsCountLocal,
      navigation,
      isUserLoggedIn,
      isPlcc,
      handleCartCheckout,
      closeCheckoutConfirmationModal,
      removeUnqualifiedItemsAndCheckout,
      isGuest,
      sflItems,
      cartSflMerged,
      fetchLabels,
      setVenmoInProgress,
      setAppleInProgress,
      isCartItemsUpdating,
      toastMessage,
      isCartItemSFL,
      isSflItemRemoved,
      isBagItemRemoved,
      isShowSaveForLaterSwitch,
      orderBalanceTotal,
      bagStickyHeaderInterval,
      toastMessagePositionInfo,
      cartItemSflError,
      isPayPalWebViewEnable,
      isPickupModalOpen,
      isMobile,
      bagPageServerError,
      isBagPage,
      setClickAnalyticsDataBag,
      cartOrderItems,
      isVenmoEnabled,
      isPayPalEnabledKillSwitch,
      isPayPalEnabled,
      isCartLoaded,
      trackPageViewBag,
      isBonusPointsEnabled,
      isModalOpen,
      bagLoading,
      isSflItemMovedToBag,
      excludedIds,
      productId,
      setCartSflMergedAction,
      isCheckoutFocused,
      appliedExpiredCoupon,
      isCartBackAbTestEnabled = false,
      isSignInBannerAbTestEnabled = false,
      isPlaceCashEnabled = false,
      setMaxItemErrorAction,
      setOOSErrorAction,
      setVMPItemErrorAction,
      setMaxItemErrorDisplayedAction,
      showMaxItemErrorDisplayed,
      isPlaceRewardEnabled = false,
      currentUserId,
      showMaxItemError,
      showOOSError,
      showVMPError,
      rememberedUser,
      isDisableBagAnchoring,
      isLowInventoryBannerEnabled,
      isLowInventoryBannerEnabledForOldDesign,
      isSpcBag,
      isHideStickyCheckoutButton,
      isMiniBagOpen,
      getVMPNavigationXHR,
      bagPageLoading,
      quickViewLoader,
      quickViewProductId,
      getEstimatedTaxAction,
      getIsFromEstimatedTaxForm,
      isShouldShowToastRedesign,
      fireHapticFeedback,
      isStickyCheckoutButtonEnabled,
      getIsTotalCalculatedAction,
      isTotalCalculatedAmt,
      calculatedTax,
      estimatedTotalOrder,
      showBackPackDeletedError,
      setBackPackDeletedErrorAction,
      isPlccCheckoutEnabled,
      orderType,
      appliedGiftCards,
      isSyteEnabled,
      route,
      isExpressAfterpayEnabled,
      afterPayMinOrderAmount,
      startExpressCheckoutHandler,
      isBIACombinedCarouselEnabled,
      toggleSPCFlag,
      showCouponsDrawer,
      afterPayMaxOrderAmount,
      newEstimatedTotalOnBag,
      isNewCouponPositionEnabled,
      isChangeRecomPositionEnabled,
      couponSectionNewDesign,
      isNewPlccEnabledAbtest,
      openApplyNowModal,
      orderPriceBreakup,
      isCouponSmoothScrollEnabled,
      isRecommendationCarouselRedesignEnabled,
      isCouponCodePlacementAbtestEnabled,
      isBossCart,
      moveItemsToBossUnavailableListAction,
      isBossEnabled,
      bossUnavailableSwitch,
      bossUnavailableProducts,
      getBossUnavailableListAction,
      isShareCartEnabled,
      saveShareCart,
      shareCartError,
      saveShareCartErrActn,
      trackClickOnCart,
      oosBossProductList,
      fetchBagOutfitProductsActn,
      outfitCountOnBag,
      isOutfitsOnBagEnabled,
      bagOutfitProducts,
      freeShippingMessagingEnabled,
      shipments,
      freeShippingThreshold,
      productTotal,
      dynamicShippingCharge,
      shippingMethodSelected,
      isMixedOrder,
      isFreeShippingProgressBarDisabled,
      isShippingOrder,
      currencySymbol,
      isSiteWidePromoBannerAbTestEnabled,
      isExtendedHolidayReturnsBannerAbTestEnabled,
      isHolidayGetItByMessageBannerAbTestEnabled,
      isDefaultSocialProofBanner,
      setDefaultBannerAction,
      timerDeadlineValue,
      isFreeShippingCouponApplied,
      isDesktopProductTileCleanUpDisabled,
      isShowBagSimplifiedHeader,
      initialSFLItemsQty,
      plccOfferPercentage,
      freeShippingPromoType,
      freeShippingMessageForPromosEnabled,
      isInternationalShipping,
      updateStoreItem,
      isEnableShipmentTilesForInternationalSite,
      isHeaderScrollViewDisabled,
      isMobileWebTileEnhancementEnabled,
      isGlobalHeaderRedesignEnabled,
      isGlobalDefaultHeaderRedesignEnabled,
      newGlobalErrorMessage,
      isPriceDropNotificationEnabled,
      isPriceDropNotificationApiEnabled,
      triggerPriceDropNotificationAction,
      priceDropPercentageValue,
      priceDropHolidayDateList,
      updatePriceDropItemValuesAction,
      updatePriceDropItemValuesInSflAction,
      getCartDataAction,
      hasSflCallCompleted,
      onApplyCouponToBagFromList,
      lastAppliedCouponData,
      openCouponDetailModal,
      setOpenCouponDetailModal,
      isPayPalDisabled,
      isAdyenPaymentEnabled,
    } = this.props;
    const { extraConfig } = this.context;
    const { isHeaderStickyClassPresent, stickyHeaderHeight, headerMiddleNavHeight } =
      extraConfig || {};

    const showOutfitsOnBag = isOutfitsOnBagEnabled && excludedIds && bagOutfitProducts?.length;
    const isDeadlinePassed = BagPageUtils.isDeadlinePassed(
      timerDeadlineValue,
      isExtendedHolidayReturnsBannerAbTestEnabled
    );
    const hasAppliedGiftCards = appliedGiftCards?.size > 0;

    const orderBalanceTotalWithTax = getOrderTotal(calculatedTax, orderBalanceTotal);

    const isExpressAfterpayEligible =
      (isExpressAfterpayEnabled &&
        orderBalanceTotalWithTax >= afterPayMinOrderAmount &&
        orderBalanceTotalWithTax <= afterPayMaxOrderAmount) ||
      showCouponsDrawer;
    const { subTotal } = orderPriceBreakup;
    const cartItems = JSON.parse(JSON.stringify(cartOrderItems));
    const firstItemInfo = cartItems && this.getItemInfoDetails(cartItems?.[0]);
    const plccOfferPercentageValue = (100 - (plccOfferPercentage || 30)) / 100;
    const plccSubTotalValue = subTotal * (plccOfferPercentageValue || 0.7);
    const isBopisBasket = orderType === 'PURE_BOPIS';

    const hidePayPal =
      ((hasAppliedGiftCards || isMixedOrder || isBopisBasket) && isAdyenPaymentEnabled) ||
      isPayPalDisabled;

    return (
      <BagPage
        isMobile={isMobile}
        totalCount={totalCount}
        orderItemsCount={orderItemsCount}
        orderItemsCountLocal={orderItemsCountLocal}
        showAddTobag={false}
        navigation={navigation}
        isUserLoggedIn={isUserLoggedIn}
        isPlcc={isPlcc}
        isGuest={isGuest}
        closeCheckoutConfirmationModal={closeCheckoutConfirmationModal}
        removeUnqualifiedItemsAndCheckout={removeUnqualifiedItemsAndCheckout}
        handleCartCheckout={handleCartCheckout}
        sflItems={sflItems}
        cartSflMerged={cartSflMerged}
        fetchLabels={fetchLabels}
        setVenmoPaymentInProgress={setVenmoInProgress}
        setApplePaymentInProgress={setAppleInProgress}
        isCartItemsUpdating={isCartItemsUpdating}
        toastMessage={toastMessage}
        isCartItemSFL={isCartItemSFL}
        isSflItemRemoved={isSflItemRemoved}
        isBagItemRemoved={isBagItemRemoved}
        isShowSaveForLaterSwitch={isShowSaveForLaterSwitch}
        orderBalanceTotal={orderBalanceTotal}
        bagStickyHeaderInterval={bagStickyHeaderInterval}
        toastMessagePositionInfo={toastMessagePositionInfo}
        cartItemSflError={cartItemSflError}
        isPayPalWebViewEnable={isPayPalWebViewEnable}
        isPickupModalOpen={isPickupModalOpen}
        bagPageServerError={bagPageServerError}
        isBagPage={isBagPage}
        cartOrderItems={cartOrderItems}
        setClickAnalyticsDataBag={setClickAnalyticsDataBag}
        isCartLoaded={isCartLoaded}
        trackPageViewBag={trackPageViewBag}
        fromMiniBag={this.fromMiniBag}
        bagLoading={bagLoading}
        isBonusPointsEnabled={isBonusPointsEnabled}
        isVenmoEnabled={isVenmoEnabled}
        isPayPalEnabledKillSwitch={isPayPalEnabledKillSwitch}
        isModalOpen={isModalOpen}
        isPayPalEnabled={isPayPalEnabled}
        isSflItemMovedToBag={isSflItemMovedToBag}
        excludedIds={excludedIds}
        setCartSflMergedAction={setCartSflMergedAction}
        productId={productId}
        isCheckoutFocused={isCheckoutFocused}
        appliedExpiredCoupon={appliedExpiredCoupon}
        isApplePayVisible={this.isApplePayVisible}
        isCartBackAbTestEnabled={isCartBackAbTestEnabled}
        isSignInBannerAbTestEnabled={isSignInBannerAbTestEnabled}
        rememberedUser={rememberedUser}
        isPlaceCashEnabled={isPlaceCashEnabled}
        showMaxItemErrorDisplayed={showMaxItemErrorDisplayed}
        setMaxItemErrorAction={setMaxItemErrorAction}
        setOOSErrorAction={setOOSErrorAction}
        setVMPItemErrorAction={setVMPItemErrorAction}
        setMaxItemErrorDisplayedAction={setMaxItemErrorDisplayedAction}
        isPlaceRewardEnabled={isPlaceRewardEnabled}
        currentUserId={currentUserId}
        showMaxItemError={showMaxItemError}
        showOOSError={showOOSError}
        showVMPError={showVMPError}
        isDisableBagAnchoring={isDisableBagAnchoring}
        bagPageLoading={bagPageLoading}
        isNewBag
        isLowInventoryBannerEnabled={isLowInventoryBannerEnabled}
        isLowInventoryBannerEnabledForOldDesign={isLowInventoryBannerEnabledForOldDesign}
        spcBag={isSpcBag}
        isHideStickyCheckoutButton={isHideStickyCheckoutButton}
        isMiniBagOpen={isMiniBagOpen}
        getVMPNavigationXHR={getVMPNavigationXHR}
        quickViewLoader={quickViewLoader}
        quickViewProductId={quickViewProductId}
        updateStoreItem={updateStoreItem}
        getEstimatedTaxAction={getEstimatedTaxAction}
        getIsFromEstimatedTaxForm={getIsFromEstimatedTaxForm}
        isShouldShowToastRedesign={isShouldShowToastRedesign}
        fireHapticFeedback={fireHapticFeedback}
        isStickyCheckoutButtonEnabled={isStickyCheckoutButtonEnabled}
        getIsTotalCalculatedAction={getIsTotalCalculatedAction}
        isTotalCalculated={isTotalCalculatedAmt}
        calculatedEstimatedTax={calculatedTax}
        estimatedTotalOrder={estimatedTotalOrder}
        showBackPackDeletedError={showBackPackDeletedError}
        setBackPackDeletedErrorAction={setBackPackDeletedErrorAction}
        isPlccCheckoutEnabled={isPlccCheckoutEnabled && !hasAppliedGiftCards}
        orderType={orderType}
        isSyteEnabled={isSyteEnabled}
        route={route}
        isExpressAfterpayEnabled={isExpressAfterpayEligible}
        startExpressCheckoutHandler={startExpressCheckoutHandler}
        isBIACombinedCarouselEnabled={isBIACombinedCarouselEnabled}
        toggleSPC={toggleSPCFlag}
        newEstimatedTotalOnBag={newEstimatedTotalOnBag}
        isNewCouponPositionEnabled={isNewCouponPositionEnabled}
        totalAmount={this.getTotalAmount()}
        isChangeRecomPositionEnabled={isChangeRecomPositionEnabled}
        couponSectionNewDesign={couponSectionNewDesign}
        cartTotalAfterPLCCDiscount={plccSubTotalValue}
        isNewPlccEnabledAbtest={isNewPlccEnabledAbtest}
        openApplyNowModal={openApplyNowModal}
        isPlccIC={isPlccCheckoutEnabled}
        cartSubTotal={subTotal}
        isCouponSmoothScrollEnabled={isCouponSmoothScrollEnabled}
        isRecommendationCarouselRedesignEnabled={isRecommendationCarouselRedesignEnabled}
        isCouponCodePlacementAbtestEnabled={isCouponCodePlacementAbtestEnabled}
        isBossCart={isBossCart}
        moveItemsToBossUnavailableListAction={moveItemsToBossUnavailableListAction}
        isBossEnabled={isBossEnabled}
        bossUnavailableSwitch={bossUnavailableSwitch}
        bossUnavailableProducts={bossUnavailableProducts}
        getBossUnavailableListAction={getBossUnavailableListAction}
        isShareCartEnabled={isShareCartEnabled}
        saveShareCart={saveShareCart}
        shareCartError={shareCartError}
        saveShareCartErrActn={saveShareCartErrActn}
        oosBossProductList={oosBossProductList}
        trackClickOnCart={trackClickOnCart}
        fetchBagOutfitProductsActn={fetchBagOutfitProductsActn}
        outfitCountOnBag={outfitCountOnBag}
        isOutfitsOnBagEnabled={isOutfitsOnBagEnabled}
        showOutfitsOnBag={!!showOutfitsOnBag}
        bagOutfitProducts={bagOutfitProducts}
        freeShippingMessagingEnabled={freeShippingMessagingEnabled}
        shipments={shipments}
        freeShippingThreshold={freeShippingThreshold}
        productTotal={productTotal}
        dynamicShippingCharge={dynamicShippingCharge}
        shippingMethodSelected={shippingMethodSelected}
        isMixedOrder={isMixedOrder}
        isFreeShippingProgressBarDisabled={isFreeShippingProgressBarDisabled}
        isShippingOrder={isShippingOrder}
        isSiteWidePromoBannerAbTestEnabled={isSiteWidePromoBannerAbTestEnabled}
        isExtendedHolidayReturnsBannerAbTestEnabled={isExtendedHolidayReturnsBannerAbTestEnabled}
        isHolidayGetItByMessageBannerAbTestEnabled={isHolidayGetItByMessageBannerAbTestEnabled}
        isDefaultSocialProofBanner={isDefaultSocialProofBanner}
        setDefaultBannerAction={setDefaultBannerAction}
        timerDeadlineValue={timerDeadlineValue}
        isDeadlinePassed={isDeadlinePassed}
        currencySymbol={currencySymbol}
        isFreeShippingCouponApplied={isFreeShippingCouponApplied}
        isDesktopProductTileCleanUpDisabled={isDesktopProductTileCleanUpDisabled}
        isShowBagSimplifiedHeader={isShowBagSimplifiedHeader}
        initialSFLItemsQty={initialSFLItemsQty}
        plccOfferPercentage={plccOfferPercentage}
        freeShippingPromoType={freeShippingPromoType}
        freeShippingMessageForPromosEnabled={freeShippingMessageForPromosEnabled}
        firstItemInfo={firstItemInfo}
        isInternationalShipping={isInternationalShipping}
        isEnableShipmentTilesForInternationalSite={isEnableShipmentTilesForInternationalSite}
        isHeaderStickyClassPresent={isHeaderStickyClassPresent}
        isHeaderScrollViewDisabled={isHeaderScrollViewDisabled}
        stickyHeaderHeight={stickyHeaderHeight}
        isMobileWebTileEnhancementEnabled={isMobileWebTileEnhancementEnabled}
        isGlobalHeaderRedesignEnabled={isGlobalHeaderRedesignEnabled}
        isGlobalDefaultHeaderRedesignEnabled={isGlobalDefaultHeaderRedesignEnabled}
        headerMiddleNavHeight={headerMiddleNavHeight}
        newGlobalErrorMessage={newGlobalErrorMessage}
        isPriceDropNotificationEnabled={isPriceDropNotificationEnabled}
        isPriceDropNotificationApiEnabled={isPriceDropNotificationApiEnabled}
        triggerPriceDropNotificationAction={triggerPriceDropNotificationAction}
        priceDropPercentageValue={priceDropPercentageValue}
        priceDropHolidayDateList={priceDropHolidayDateList}
        updatePriceDropItemValuesAction={updatePriceDropItemValuesAction}
        updatePriceDropItemValuesInSflAction={updatePriceDropItemValuesInSflAction}
        getCartDataAction={getCartDataAction}
        hasSflCallCompleted={hasSflCallCompleted}
        onApplyCouponToBagFromList={onApplyCouponToBagFromList}
        lastAppliedCouponData={lastAppliedCouponData}
        openCouponDetailModal={openCouponDetailModal}
        setOpenCouponDetailModal={setOpenCouponDetailModal}
        isPayPalDisabled={hidePayPal}
      />
    );
  }
}

BagPageContainer.pageInfo = {
  pageId: 'Bag',
};

BagPageContainer.getInitialProps = (reduxProps, pageProps) => {
  const DEFAULT_ACTIVE_COMPONENT = 'shopping bag';
  const loadedComponent = utils.getObjectValue(reduxProps, DEFAULT_ACTIVE_COMPONENT, 'query', 'id');
  const { dispatch } = reduxProps.store;
  dispatch(updateRecommendationsLoading({ isUpdating: true }));
  return {
    ...pageProps,
    ...{
      pageData: {
        pageName: BAGPAGE_CONSTANTS.SHOPPING_BAG,
        pageSection: loadedComponent,
        pageSubSection: BAGPAGE_CONSTANTS.SHOPPING_BAG,
        pageType: BAGPAGE_CONSTANTS.SHOPPING_BAG,
        pageShortName: BAGPAGE_CONSTANTS.SHOPPING_BAG,
        loadAnalyticsOnload: false,
      },
    },
  };
};

export const mapDispatchToProps = (dispatch) => {
  const { setCartSflMerged, getEstimatedTax, isFromEstimatedTaxForm } = BAG_PAGE_ACTIONS;
  return {
    initialActions: () => {
      dispatch(BAG_PAGE_ACTIONS.getCartDataSequentially({}));
    },
    fetchNeedHelpContent: (contentIds) => {
      dispatch(BAG_PAGE_ACTIONS.fetchModuleX(contentIds));
    },
    fetchSflData: () => {
      dispatch(BAG_PAGE_ACTIONS.getSflData());
    },
    fetchLabels: () => {
      dispatch(BAG_PAGE_ACTIONS.initActions[0]);
    },
    setVenmoInProgress: (data) => {
      dispatch(setVenmoPaymentInProgress(data));
    },
    setAppleInProgress: (data) => dispatch(setApplePaymentInProgress(data)),
    setVenmoPickupState: (data) => {
      dispatch(setVenmoPickupMessageState(data));
    },
    setVenmoShippingState: (data) => {
      dispatch(setVenmoShippingMessageState(data));
    },
    toastMessage: (palyoad) => {
      dispatch(toastMessageInfo(palyoad));
    },
    toastMessagePositionInfo: (palyoad) => {
      dispatch(toastMessagePosition(palyoad));
    },
    setClickAnalyticsDataBag: (payload) => {
      dispatch(setClickAnalyticsData(payload));
    },
    trackClickAction: (data) => {
      dispatch(trackClick(data));
    },
    trackClickOnCart: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 250);
    },
    resetAnalyticsData: () => {
      dispatch(resetClickAnalyticsData());
    },
    trackPageViewBag: (payload) => {
      dispatch(trackPageView(payload));
    },
    updateBagPageData: (payload) => {
      dispatch(updatePageData(payload));
    },
    clearCheckoutServerError: (data) => dispatch(CHECKOUT_ACTIONS.setServerErrorCheckout(data)),
    resetBagLoadedState: () => {
      dispatch(BAG_PAGE_ACTIONS.resetBagLoadedState());
    },
    resetEDDCall: (clearEddData) => {
      dispatch(updateShippingCode(null));
      if (clearEddData) dispatch(resetEddData());
    },
    clearEddCache: () => {
      dispatch(clearEddTTL());
    },
    setCartSflMergedAction: (payload) => {
      dispatch(setCartSflMerged(payload));
    },
    setCouponMergeErrorAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setCouponMergeError(payload));
    },
    setMaxItemErrorAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setMaxItemError(payload));
    },
    setOOSErrorAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setOOSError(payload));
    },
    setVMPItemErrorAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setVMPItemError(payload));
    },
    setBackPackDeletedErrorAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setBackPackDeletedError(payload));
    },
    setMaxItemErrorDisplayedAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setMaxItemErrorDisplayed(payload));
    },
    getHomePageLayout: (apiConfig) => {
      dispatch(fetchPageLayout({ pageName: 'home', apiConfig }));
    },
    resetCartsSessionStatus: () => {
      dispatch(setCartsSessionStatus(0));
    },
    getVMPNavigationXHR: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.getVMPNavigationXHR(payload));
    },
    updateStoreItem: (payload, enableModal) => {
      dispatch(updateItem(payload, enableModal));
    },
    getEstimatedTaxAction: (payload) => {
      dispatch(getEstimatedTax(payload));
    },
    getIsFromEstimatedTaxForm: (payload) => {
      dispatch(isFromEstimatedTaxForm(payload));
    },
    resetTaxEstimationValueActn: () => {
      dispatch(resetTaxEstimationValue());
    },
    getIsTotalCalculatedAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.isTotalCalculated(payload));
    },
    setCartItemsSflError: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setCartItemsSflError(payload));
    },
    setExpressCallThroughPlccICFailure: (payload) => {
      dispatch(isExpressCallThroughPlccICFailure(payload));
    },
    getAddressListActn: (payload) => {
      dispatch(getAddressList(payload));
    },
    getAddressPlccActn: (payload) => {
      dispatch(getAddressListPlcc(payload));
    },
    resetCoupontaxFlag: (payload) => {
      dispatch(couponCalculatetax(payload));
    },
    getFullCardsList: () => {
      dispatch(getCardList());
    },
    startExpressCheckoutHandler: () => {
      dispatch(BAG_PAGE_ACTIONS.startExpressCheckoutActn());
    },
    toggleSPCFlag: (payload) => dispatch(toggleSPC(payload)),
    openApplyNowModal: (payload) => {
      dispatch(toggleApplyNowModal(payload));
    },
    clearRecommendationDataForCart: (payload) => {
      dispatch(clearRecommendationData(payload));
    },
    saveShareCart: () => dispatch(saveShareCartActn()),
    saveShareCartErrActn: (payload) => dispatch(saveShareCartErr(payload)),
    moveItemsToBossUnavailableListAction: (payload) => {
      dispatch(moveItemsToBossUnavailableList(payload));
    },
    getBossUnavailableListAction: () => dispatch(getBossUnavailableList()),
    fetchBagOutfitProductsActn: (payload) => {
      dispatch(fetchBagOutfitProducts(payload));
    },
    setDefaultBannerAction: (payload) => {
      dispatch(setDefaultBanner(payload));
    },
    togglePlccModalStateAction: (payload) => dispatch(togglePlccLoginModal(payload)),
    triggerPriceDropNotificationAction: (payload) =>
      dispatch(triggerPriceDropNotification(payload)),
    updatePriceDropItemValuesAction: (payload) => dispatch(updatePriceDropItemValues(payload)),
    updatePriceDropItemValuesInSflAction: (payload) =>
      dispatch(updatePriceDropItemValuesInSfl(payload)),
    getCartDataAction: (payload) => dispatch(BAG_PAGE_ACTIONS.getCartData(payload)),
    onApplyCouponToBagFromList: (coupon) => {
      return new Promise((resolve, reject) => {
        dispatch(
          applyCoupon({
            formData: { couponCode: coupon.id },
            formPromise: { resolve, reject },
            coupon,
            fromCartPage: 'false',
          })
        );
      });
    },
    setOpenCouponDetailModal: (payload) => dispatch(setOpenCouponDetailModalActn(payload)),
    setLastAppliedCouponActn: (payload) => dispatch(setLastAppliedCoupon(payload)),
  };
};

function shouldDisableAdyenForPickup(
  isAdyenPaymentEnabled,
  isPickuOrder,
  isPayPalDisabledForPickupOrders
) {
  return isAdyenPaymentEnabled && isPickuOrder && isPayPalDisabledForPickupOrders;
}

// Helper function to disable Adyen payment
function disableAdyenPayment() {
  return {
    isAdyenPaymentEnabled: false,
    isPayPalDisabled: true,
  };
}

// Helper function to get the count of stores
function getStoreCount(stores) {
  return Array.isArray(stores) ? stores.length : 0;
}

// Helper function to check if the stores are the same
function areStoresSame(stores) {
  if (!Array.isArray(stores) || stores.length < 2) return false;
  const [firstStore, secondStore] = stores;
  return firstStore?.stLocId === secondStore?.stLocId;
}

// Helper function to determine if Adyen should be disabled for multiple stores
function shouldDisableAdyenForStores(storeCount, sameStore) {
  return storeCount > 1 && !sameStore;
}

function updatePaymentStatus(state) {
  let isPayPalDisabled = getIsPayPalDisabled(state);
  const isPayPalDisabledForPickupOrders = getIsPayPalDisabledForPickupOrders(state);
  const isPickuOrder = isPickuOrderStatus(state);
  let isAdyenPaymentEnabled = getIsAdyenPaymentEnabled(state);

  if (
    shouldDisableAdyenForPickup(
      isAdyenPaymentEnabled,
      isPickuOrder,
      isPayPalDisabledForPickupOrders
    )
  ) {
    ({ isAdyenPaymentEnabled, isPayPalDisabled } = disableAdyenPayment());
  }

  const stores = BagPageSelector.getBossBopisStore(state);
  const storeCount = getStoreCount(stores);
  const sameStore = areStoresSame(stores);

  if (shouldDisableAdyenForStores(storeCount, sameStore)) {
    ({ isAdyenPaymentEnabled, isPayPalDisabled } = disableAdyenPayment());
  }

  return { isAdyenPaymentEnabled, isPayPalDisabled };
}

export const mapStateToProps = (state) => {
  const { size = false } = getCartOrderList(state) || {};
  const enableEstimatedTaxSiteDetails = estimatedTaxBagPageEnabled(state);
  const enableEstimatedTax = getIsGuest(state)
    ? parseBoolean(enableEstimatedTaxSiteDetails.GUEST_ESTIMATED_TAX_BAG_PAGE_ENABLED)
    : parseBoolean(enableEstimatedTaxSiteDetails.ESTIMATED_TAX_BAG_PAGE_ENABLED);
  const { isAdyenPaymentEnabled, isPayPalDisabled } = updatePaymentStatus(state);
  return {
    isMobile: checkoutSelectors.getIsMobile(),
    checkoutAddress: getShippingValues(state),
    totalCount: BagPageSelector.getTotalItems(state),
    productsTypes: BagPageSelector.getProductsTypes(state),
    orderItemsCount: size,
    orderItemsCountLocal: BagPageSelector.getOrderItemsLocal(state)
      ? BagPageSelector.getOrderItemsLocal(state).size
      : 0,
    airmilesBannerContentId: PlaceCashSelector.getAirmilesBannerContentInfo(),
    isVenmoEnabled: checkoutSelectors.getIsVenmoEnabled(state),
    isApplePayEnabled: checkoutSelectors.getIsApplePayEnabled(state),
    isApplePayRememberedUser: checkoutSelectors.getIsApplePayRememberedUser(state),
    rememberedUser: isRememberedUser(state),
    isPayPalEnabledKillSwitch: getIsPayPalEnabled(state),
    isPayPalEnabled: BagPageSelector.getIsPayPalEnabled(state),
    isUserLoggedIn: getUserLoggedInState(state),
    isGuest: isGuestUser(state),
    isPlcc: isPlccUser(state),
    bagPageLoading: BagPageSelector.getIsBagPageLoading(state),
    sflItems: BagPageSelector.getsflItemsList(state),
    cartSflMerged: BagPageSelector.getCartSflMerged(state),
    isCartItemsUpdating: getIsCartItemsUpdating(state),
    isCartItemSFL: getIsCartItemsSFL(state),
    isSflItemRemoved: getIsSflItemRemoved(state),
    isBagItemRemoved: getIsBagItemRemoved(state),
    isSflItemMovedToBag: getIsSflItemMovedToBag(state),
    isShowSaveForLaterSwitch: getSaveForLaterSwitch(state),
    orderBalanceTotal: getGrandTotal(state) - getGiftCardsTotal(state),
    bagStickyHeaderInterval: BagPageSelector.getBagStickyHeaderInterval(state),
    cartItemSflError: getCartItemsSflError(state),
    isPayPalWebViewEnable: BagPageSelector.getPayPalWebViewStatus(state),
    currencySymbol: BagPageSelector.getCurrentCurrency(state) || '$',
    isRegisteredUserCallDone: getIsRegisteredUserCallDone(state),
    isPickupModalOpen: getIsPickupModalOpen(state),
    isModalOpen: getModalState(state),
    bagPageServerError: checkoutSelectors.getCheckoutServerError(state),
    cartOrderItems: BagPageSelector.getOrderItems(state),
    isCartLoaded: BagPageSelector.getCartLoadedState(state),
    bagPageIsRouting: BagPageSelector.isBagRouting(state),
    isCartSupressOnBagUpdate: BagPageSelector.getCartSupressOnBagUpdate(state),
    bagLoading: BagPageSelector.isBagLoading(state),
    isBonusPointsEnabled: getBonusPointsSwitch(state),
    excludedIds: BagPageSelector.getCartProductIds(state),
    productId: BagPageSelector.getMostExpensiveItemId(state),
    pageName: getPageName(state),
    venmoOrderConfirmationId: ConfirmationSelector.getVenmoOrderConfirmationContentId(
      'Venmo_Order_Confirmation'
    ),
    isCheckoutFocused: checkoutSelectors.isCheckoutFocused(state),
    appliedExpiredCoupon: getAppliedExpiredCouponListState(state),
    isRecalculateTaxes: getIsChangeRecalForEcom(state),
    isECOM: getECOMStatus(state),
    isCartBackAbTestEnabled: BagPageSelector.getCartBackAbTest(state),
    isSignInBannerAbTestEnabled: BagPageSelector.getSignInBannerAbTest(state),
    isPlaceCashEnabled: BagPageSelector.getIsPlaceCashEnabled(state),
    isPlaceRewardEnabled: BagPageSelector.getIsPlaceRewardEnabled(state),
    currentUserId: getUserId(state),
    showMaxItemErrorDisplayed: BagPageSelector.getShowMaxItemErrorDisplayed(state),
    showMaxItemError: BagPageSelector.getShowMaxItemError(state),
    showOOSError: BagPageSelector.getShowOOSError(state),
    showBackPackDeletedError: BagPageSelector.getShowBackPackDeletedError(state),
    showVMPError: BagPageSelector.getShowVMPError(state),
    layouts: state.Layouts,
    cartsSessionStatus: getCartsSessionStatus(state),
    isDisableBagAnchoring: getIsDisableBagAnchoring(state),
    isLowInventoryBannerEnabled: getIsShowLowInventoryBanner(state),
    isHideStickyCheckoutButton: getIsHideStickyCheckoutButton(state),
    isLowInventoryBannerEnabledForOldDesign: getIsShowLowInventoryBannerForOldDesign(state),
    isSpcBag: true,
    isMiniBagOpen: getIsMiniBagOpen(state),
    quickViewLoader: getQuickViewLoader(state),
    quickViewProductId: getUniqueId(state),
    isShouldShowToastRedesign: BagPageSelector.getToastRedesign(state),
    isStickyCheckoutButtonEnabled: getIsStickyCheckoutAbTestEnabled(state),
    isTotalCalculatedAmt: BagPageSelector.getIsTotalCalculated(state),
    calculatedTax: BagPageSelector.getCalculatedEstimatedTax(state),
    firstTouchValue: getFirstTimeCaptureBanner(state),
    firstTouchShopMenu: getFirstTimeCaptureShopMenu(state),
    estimatedTotalOrder: getOrderTotalAmount(state),
    cd66Data: getCD66Data(state),
    cd81Data: getCD81Data(state),
    getDefaultAddressValue: getDefaultAddress(state),
    isPlccCheckoutEnabled: getIsPlccCheckoutEnabled(state),
    orderType: BagPageSelector.getOrderType(state),
    appliedGiftCards: GiftCardsSelectors.getAppliedGiftCards(state),
    isSyteEnabled: getIsSyteEnabled(state),
    isCouponCalculateTax: BagPageSelector.getIsCouponCalculateTax(state),
    isCardsList: getCardsList(state),
    isExpressAfterpayEnabled: getIsExpressAfterpayEnabled(state),
    afterPayMinOrderAmount: getAfterPayMinOrderAmount(state),
    afterPayMaxOrderAmount: getAfterPayMaxOrderAmount(state),
    isBIACombinedCarouselEnabled: getIsBIACombinedCarouselKillSwitch(state),
    showCouponsDrawer: checkoutSelectors.getShowCouponsDrawer(state),
    newEstimatedTotalOnBag: getIsEstimatedTotalOnBag(state),
    isNewCouponPositionEnabled: getIsNewCouponPlacementEnable(state),
    orderPriceBreakup: getLedgerSummaryData(state),
    isPlccShippingAddressUpdated: getIsPlccShippingAddressUpdate(state),
    isEstimatedTaxBagPageEnabled: enableEstimatedTax,
    isInternationalShipping: getIsInternationalShipping(state),
    isChangeRecomPositionEnabled: getRecommendationsPlacementAbTest(state),
    couponSectionNewDesign: getcouponSectionNewDesign(state),
    isNewPlccEnabledAbtest: getIsNewPlccEnabledAbtest(state),
    isCouponSmoothScrollEnabled: getIsCouponSmoothScrollEnabled(state),
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
    isRecommendationCarouselRedesignEnabled: getIsRecommendationCarouselRedesignEnabled(state),
    isCouponCodePlacementAbtestEnabled: getCouponCodePlacementAbtest(state),
    isBossCart: getBossStatus(state),
    isBossEnabled: getIsBossEnabled(state),
    bossUnavailableSwitch: getBossUnavailableSwitch(state),
    bossUnavailableProducts: getBossUnavailableProduct(state),
    isShareCartEnabled: getIsShareCartEnabled(state),
    shareCartError: getShareCartError(state),
    oosBossProductList: getBossUnavailableProductInList(state),
    outfitCountOnBag: getOutfitCountOnBag(state),
    isOutfitsOnBagEnabled: getIsOutfitsOnBagEnabled(state),
    bagOutfitProducts: getBagOutfitProducts(state),
    freeShippingMessagingEnabled: getIsFreeShippingMessagingEnabled(state),
    shipments: getOrderShipments(state),
    productTotal: getProductTotal(state),
    freeShippingThreshold: getFreeShippingThresholdValue(state),
    dynamicShippingCharge: getDynamicShippingCharge(state),
    shippingMethodSelected: checkoutSelectors.getSavedShippingMethod(state),
    isMixedOrder: isMixedOrderStatus(state),
    isFreeShippingProgressBarDisabled: getIsFreeShippingProgressBarDisabled(state),
    isShippingOrder: isECOMStatus(state) || isMixedOrderStatus(state) || false,
    isSiteWidePromoBannerAbTestEnabled: getIsSiteWidePromoBannerAbTestEnabled(state),
    isExtendedHolidayReturnsBannerAbTestEnabled:
      getIsExtendedHolidayReturnsBannerAbTestEnabled(state),
    isHolidayGetItByMessageBannerAbTestEnabled:
      getIsHolidayGetItByMessageBannerAbTestEnabled(state),
    isDefaultSocialProofBanner: BagPageSelector.getDefaultSocialProofBanner(state),
    timerDeadlineValue: getDeadlineDateAndTime(state),
    logoutInProgress: getLogoutInProgress(state),
    isFreeShippingCouponApplied: getIsFreeShippingCouponApplied(state),
    isDesktopProductTileCleanUpDisabled: getDesktopProductTileCleanUpDisabled(state),
    isShowBagSimplifiedHeader: getIsShowBagSimplifiedHeader(state),
    initialSFLItemsQty: getInitialSFLItemsQty(state),
    plccOfferPercentage: getPLCCDiscountValue(state) || getPlccOfferPercentage(state),
    freeShippingPromoType: getFreeShippingType(state),
    freeShippingMessageForPromosEnabled: freeShippingMessageForPromos(state),
    isEnableShipmentTilesForInternationalSite: getIsEnableShipmentTilesForInternationalSite(state),
    isHeaderScrollViewDisabled: getIsHeaderScrollViewDisabled(state),
    isMobileWebTileEnhancementEnabled: getMobileWebProductTileEnhancement(state),
    isGlobalHeaderRedesignEnabled: getIsRedesignGlobalHeaderEnabled(state),
    isGlobalDefaultHeaderRedesignEnabled: getIsGlobalDefaultHeaderRedesignEnabled(state),
    newGlobalErrorMessage: getNewGlobalErrorMessage(state),
    isPriceDropNotificationEnabled: getIsPriceDropNotificationEnabled(state),
    isPriceDropNotificationApiEnabled: getIsPriceDropNotificationApiEnabled(state),
    priceDropPercentageValue: priceDropPercentage(state),
    priceDropHolidayDateList: priceDropHolidayList(state),
    hasSflCallCompleted: getHasSflCallCompleted(state),
    lastAppliedCouponData: getLastAppliedCouponData(state),
    openCouponDetailModal: getOpenCouponDetailModal(state),
    isPayPalDisabled,
    isAdyenPaymentEnabled,
  };
};

BagPageContainer.propTypes = {
  fetchNeedHelpContent: PropTypes.func.isRequired,
  resetAnalyticsData: PropTypes.func.isRequired,
  venmoOrderConfirmationId: PropTypes.string.isRequired,
  airmilesBannerContentId: PropTypes.string.isRequired,
  setVenmoPickupState: PropTypes.func.isRequired,
  setVenmoShippingState: PropTypes.func.isRequired,
  setVenmoInProgress: PropTypes.func.isRequired,
  isRegisteredUserCallDone: PropTypes.bool.isRequired,
  router: PropTypes.shape({}).isRequired,
  bagPageIsRouting: PropTypes.bool.isRequired,
  isCartLoaded: PropTypes.bool.isRequired,
  pageName: PropTypes.string.isRequired,
  cartOrderItems: PropTypes.shape([]).isRequired,
  resetBagLoadedState: PropTypes.func.isRequired,
  setClickAnalyticsDataBag: PropTypes.func.isRequired,
  trackPageViewBag: PropTypes.func.isRequired,
  updateBagPageData: PropTypes.func.isRequired,
  navigation: PropTypes.shape({}).isRequired,
  initialActions: PropTypes.func.isRequired,
  fetchSflData: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  orderItemsCount: PropTypes.number.isRequired,
  orderItemsCountLocal: PropTypes.number.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  isPlcc: PropTypes.bool.isRequired,
  handleCartCheckout: PropTypes.func.isRequired,
  closeCheckoutConfirmationModal: PropTypes.func.isRequired,
  removeUnqualifiedItemsAndCheckout: PropTypes.func.isRequired,
  isGuest: PropTypes.bool.isRequired,
  sflItems: PropTypes.shape([]).isRequired,
  cartSflMerged: PropTypes.bool.isRequired,
  fetchLabels: PropTypes.func.isRequired,
  isCartItemsUpdating: PropTypes.bool.isRequired,
  toastMessage: PropTypes.string.isRequired,
  isCartItemSFL: PropTypes.bool.isRequired,
  isSflItemRemoved: PropTypes.bool.isRequired,
  isBagItemRemoved: PropTypes.bool.isRequired,
  isShowSaveForLaterSwitch: PropTypes.bool.isRequired,
  orderBalanceTotal: PropTypes.number.isRequired,
  bagStickyHeaderInterval: PropTypes.number.isRequired,
  toastMessagePositionInfo: PropTypes.func.isRequired,
  isPayPalWebViewEnable: PropTypes.bool.isRequired,
  isPickupModalOpen: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isBagPage: PropTypes.bool.isRequired,
  isVenmoEnabled: PropTypes.bool.isRequired,
  isPayPalEnabled: PropTypes.bool.isRequired,
  isBonusPointsEnabled: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  bagLoading: PropTypes.bool.isRequired,
  isSflItemMovedToBag: PropTypes.bool.isRequired,
  excludedIds: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  isCheckoutFocused: PropTypes.bool.isRequired,
  cartItemSflError: PropTypes.string.isRequired,
  bagPageServerError: PropTypes.shape({}).isRequired,
  clearCheckoutServerError: PropTypes.func.isRequired,
  appliedExpiredCoupon: PropTypes.shape({}).isRequired,
  setCartSflMergedAction: func.isRequired,
  resetEDDCall: PropTypes.func.isRequired,
  setAppleInProgress: PropTypes.func.isRequired,
  isApplePayEnabled: PropTypes.bool.isRequired,
  isRecalculateTaxes: PropTypes.bool.isRequired,
  isECOM: PropTypes.bool.isRequired,
  rememberedUser: PropTypes.bool.isRequired,
  isApplePayRememberedUser: PropTypes.bool.isRequired,
  isPayPalEnabledKillSwitch: PropTypes.bool.isRequired,
  isCartBackAbTestEnabled: PropTypes.bool.isRequired,
  isSignInBannerAbTestEnabled: PropTypes.bool.isRequired,
  isCartSupressOnBagUpdate: PropTypes.bool.isRequired,
  currentUserId: PropTypes.string.isRequired,
  showMaxItemError: PropTypes.bool.isRequired,
  showOOSError: PropTypes.bool.isRequired,
  showVMPError: PropTypes.bool.isRequired,
  showMaxItemErrorDisplayed: bool.isRequired,
  setCouponMergeErrorAction: PropTypes.func.isRequired,
  setMaxItemErrorDisplayedAction: PropTypes.func.isRequired,
  setMaxItemErrorAction: PropTypes.func.isRequired,
  setOOSErrorAction: PropTypes.func.isRequired,
  setVMPItemErrorAction: PropTypes.func.isRequired,
  layouts: PropTypes.shape({}).isRequired,
  getHomePageLayout: PropTypes.func.isRequired,
  cartsSessionStatus: PropTypes.number.isRequired,
  resetCartsSessionStatus: PropTypes.func.isRequired,
  isDisableBagAnchoring: PropTypes.bool,
  trackClickAction: PropTypes.func.isRequired,
  isLowInventoryBannerEnabled: PropTypes.bool,
  isLowInventoryBannerEnabledForOldDesign: PropTypes.bool,
  isSpcBag: PropTypes.bool,
  isMiniBagOpen: PropTypes.bool,
  bagPageLoading: PropTypes.bool,
  route: PropTypes.shape({}),
  screenProps: PropTypes.shape({}),
  resetTaxEstimationValueActn: PropTypes.func,
  isSyteEnabled: PropTypes.bool,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
  session: PropTypes.shape({}),
  isHeaderScrollViewDisabled: PropTypes.bool,
};

BagPageContainer.defaultProps = {
  isDisableBagAnchoring: false,
  isLowInventoryBannerEnabled: false,
  isLowInventoryBannerEnabledForOldDesign: false,
  isSpcBag: false,
  isMiniBagOpen: false,
  bagPageLoading: false,
  screenProps: {},
  route: {},
  resetTaxEstimationValueActn: () => {},
  User: {},
  APIConfig: {},
  session: {},
  isHeaderScrollViewDisabled: false,
};

const withReducer = withDynamicReducer([
  { key: 'PaymentReducer', reducer: PaymentReducer },
  { key: 'CartItemTileReducer', reducer: CartTileReducer },
  { key: 'ApplyNowModal', reducer: ApplyNowModalPLCCReducer },
  { key: 'Edd', reducer: EddReducer },
  { key: 'AddressBookReducer', reducer: AddressBookReducer },
]);
const withSaga = withDynamicSaga([
  { key: 'CartPageSaga', saga: CartPageSaga },
  { key: 'Checkout', saga: CheckoutDynamicSaga },
  { key: 'SinglePageCheckoutSaga', saga: SinglePageCheckoutSaga },
  { key: 'PaymentSaga', saga: PaymentSaga },
  { key: 'DeleteCardSaga', saga: DeleteCardSaga },
  { key: 'DefaultPaymentSaga', saga: DefaultPaymentSaga },
  { key: 'BillingPaymentSaga', saga: BillingPaymentSaga },
  { key: 'EddSaga', saga: EddSaga },
  { key: 'addressBookSaga', saga: AddressBookSaga },
]);
export default compose(
  withReducer,
  withSaga,
  connect(mapStateToProps, mapDispatchToProps)
)(BagPageContainer);
